import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Logo from '../../components/ui/Logo';
import './Home.css';

const Home = () => {
  const features = [
    {
      icon: '🚀',
      title: 'Innovación Constante',
      description: 'Utilizamos las últimas tecnologías para mantener tu negocio a la vanguardia del mercado digital.'
    },
    {
      icon: '⚡',
      title: 'Desarrollo Ágil',
      description: 'Metodologías ágiles que garantizan entregas rápidas sin comprometer la calidad del producto.'
    },
    {
      icon: '🎯',
      title: 'Enfoque Personalizado',
      description: 'Cada solución está diseñada específicamente para tus necesidades y objetivos únicos.'
    },
    {
      icon: '🔒',
      title: 'Seguridad Garantizada',
      description: 'Implementamos las mejores prácticas de seguridad en cada línea de código que escribimos.'
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero__background">
          <div className="hero__gradient"></div>
          <div className="hero__pattern"></div>
        </div>
        
        <div className="container">
          <div className="hero__content">
            <motion.div
              className="hero__text"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h1 className="hero__title">
                De la idea al <br />
                <span className="gradient-text">producto</span><br /> 
                desde la <span className="gradient-text">estrategia</span> hasta la <span className="gradient-text">nube</span>
              </h1>
              <p className="hero__description">
                Convertimos tu visión en un plan claro, reducimos riesgos desde el discovery y construimos productos digitales escalables con arquitectura cloud e inteligencia artificial.
              </p>
              <div className="hero__actions">
                <Link to="/contact" className="btn btn--primary btn--large">
                  Agendar una llamada
                </Link>
                <Link to="/services" className="btn btn--secondary btn--large">
                  Conoce nuestra metodología
                </Link>
              </div>
            </motion.div>
            
            <motion.div
              className="hero__visual"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="hero__logo-container">
                <Logo width={280} className="hero__logo" />
                <div className="hero__logo-glow"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features section">
        <div className="container">
          <motion.div
            className="features__header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="features__title">¿Por qué elegir <span className="gradient-text">Duit.tech</span>?</h2>
            <p className="features__description">
              Combinamos experiencia técnica con visión estratégica para entregar 
              soluciones que realmente impactan tu negocio.
            </p>
          </motion.div>

          <div className="features__grid">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="feature-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="feature-card__icon">{feature.icon}</div>
                <h3 className="feature-card__title">{feature.title}</h3>
                <p className="feature-card__description">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats section">
        <div className="container">
          <div className="stats__grid">
            {[
              { number: '50+', label: 'Proyectos Completados' },
              { number: '98%', label: 'Satisfacción del Cliente' },
              { number: '24/7', label: 'Soporte Técnico' },
              { number: '5★', label: 'Calificación Promedio' }
            ].map((stat, index) => (
              <motion.div
                key={index}
                className="stat-card"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="stat-card__number">{stat.number}</div>
                <div className="stat-card__label">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta section">
        <div className="container">
          <motion.div
            className="cta__content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="cta__title">¿Listo para transformar tu negocio?</h2>
            <p className="cta__description">
              Conversemos sobre tu proyecto y descubre cómo podemos ayudarte a alcanzar tus objetivos.
            </p>
            <Link to="/contact" className="btn btn--primary btn--large">
              Contactar Ahora
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;
